// MARK://dhk8/admin-shell/pages/modules/InvoiceDetailPage
// Detalle de un CFDI + cancelación → dhk8-erp-invoices + dhk8-fiscal-cfdi (REST + mock).
import { useState } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { getInvoice, cancelInvoice } from '../../lib/clients/invoices.js'
import { useAsync, asyncState } from '../../lib/use-async.js'
import { mxn } from '../../lib/money.js'
import Sheet from '../../components/Sheet.js'

const STATUS_LABEL: Record<string, string> = { STAMPED: 'Timbrada', CANCELED: 'Cancelada', PENDING: 'Pendiente' }
const CANCEL_REASONS = [
  { code: '01', label: '01 — Comprobante emitido con errores con relación' },
  { code: '02', label: '02 — Comprobante emitido con errores sin relación' },
  { code: '03', label: '03 — No se llevó a cabo la operación' },
  { code: '04', label: '04 — Operación nominativa en factura global' },
]

export default function InvoiceDetailPage() {
  const { id = '' } = useParams()
  const nav = useNavigate()
  const { data, loading, error, reload } = useAsync((s) => getInvoice(id, s), [id])
  const [cancelOpen, setCancelOpen] = useState(false)
  const [reason, setReason] = useState('02')
  async function doCancel() { await cancelInvoice(id, reason); setCancelOpen(false); reload() }
  return (
    <div className="adm-page">
      <div className="adm-page__head">
        <div><h1 className="adm-page__title">CFDI {data?.folio ?? ''}</h1><p className="adm-page__sub">{data ? `${STATUS_LABEL[data.status]} · ${data.date}` : ''}</p></div>
        <div className="adm-page__actions">
          <Link to="/invoices" className="adm-btn adm-btn--sm">← Facturas</Link>
          {data?.status === 'STAMPED' && <button className="adm-btn adm-btn--danger" onClick={() => setCancelOpen(true)}>Cancelar CFDI</button>}
        </div>
      </div>
      {asyncState(loading, error, reload)}
      {data === null && !loading && <div className="adm-empty">Factura no encontrada.</div>}
      {data && (
        <div className="adm-card">
          <dl style={{ display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '8px 24px', margin: 0, fontSize: 14 }}>
            <dt className="adm-row__meta">Folio</dt><dd style={{ margin: 0 }}>{data.folio}</dd>
            <dt className="adm-row__meta">Cliente</dt><dd style={{ margin: 0 }}>{data.customer}</dd>
            <dt className="adm-row__meta">RFC</dt><dd style={{ margin: 0 }}>{data.rfc}</dd>
            <dt className="adm-row__meta">Total</dt><dd style={{ margin: 0 }}>{mxn(data.totalCents)}</dd>
            <dt className="adm-row__meta">Fecha</dt><dd style={{ margin: 0 }}>{data.date}</dd>
            <dt className="adm-row__meta">Estado</dt><dd style={{ margin: 0 }}>{STATUS_LABEL[data.status]}</dd>
            <dt className="adm-row__meta">UUID</dt><dd style={{ margin: 0, fontFamily: 'var(--font-mono, monospace)', fontSize: 12 }}>{data.uuid || '— (sin timbrar)'}</dd>
          </dl>
          <div style={{ marginTop: 16, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <button className="adm-btn adm-btn--sm" disabled title="Próximamente">Descargar PDF</button>
            <button className="adm-btn adm-btn--sm" disabled title="Próximamente">Descargar XML</button>
            <span className="adm-row__meta">Descarga de PDF/XML — próximamente</span>
          </div>
        </div>
      )}
      <Sheet open={cancelOpen} title="Cancelar CFDI" onClose={() => setCancelOpen(false)} footer={<><button className="adm-btn" onClick={() => setCancelOpen(false)}>No cancelar</button><button className="adm-btn adm-btn--danger" onClick={doCancel}>Confirmar cancelación</button></>}>
        <label className="adm-field"><span className="adm-field__label">Motivo de cancelación (SAT)</span><select className="adm-select" value={reason} onChange={(e) => setReason(e.target.value)}>{CANCEL_REASONS.map((r) => <option key={r.code} value={r.code}>{r.label}</option>)}</select></label>
      </Sheet>
      {data?.status === 'CANCELED' && <button className="adm-btn adm-btn--sm" onClick={() => nav('/invoices')}>Volver a la lista</button>}
    </div>
  )
}
